import React from 'react';
import { TextField } from '@mui/material';

export function ManualAmountInput({
  ariaLabel,
  value,
  onChange,
  disabled,
  width = 132,
  isOverallCompact = false,
  placeholder = '$0.00',
}: {
  ariaLabel: string;
  value: string;
  onChange: (nextValue: string) => void;
  disabled: boolean;
  width?: number;
  isOverallCompact?: boolean;
  placeholder?: string;
}) {
  return (
    <TextField
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      inputProps={{
        inputMode: 'decimal',
        'aria-label': ariaLabel,
      }}
      sx={{
        width,
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#fff',
          borderRadius: '4px',
          height: isOverallCompact ? '22px' : '32px',
        },
        '& .MuiOutlinedInput-input': {
          margin: '0 !important',
          textAlign: 'right',
          padding: isOverallCompact ? '4px 12px' : '8px 12px',
          '&::placeholder': {
            fontSize: '14px !important',
          },
        },
      }}
    />
  );
}
